import React, { useEffect, useRef, useState } from "react";

const CounterBox = ({ labelTop, labelBottom, target, isVisible }) => {
    const [count, setCount] = useState(0);

    useEffect(() => {
        if (!isVisible) return; 

        let start = 0;
        const duration = 800; 
        const increment = target / (duration / 16);
        let rafId;

        const updateCounter = () => {
            start += increment;
            if (start < target) {
                setCount(Math.ceil(start));
                rafId = requestAnimationFrame(updateCounter);
            } else {
                setCount(target);
            }
        };

        rafId = requestAnimationFrame(updateCounter);
        return () => cancelAnimationFrame(rafId);
    }, [isVisible, target]);

    return (
        <div className="counter-box">
            <div className="counter-text">
                {labelTop}
                <br />
                {labelBottom}
            </div>
            <div className="counter-number">{count}+</div>
        </div>
    );
};

const CountersSection = () => {
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => setIsVisible(entry.isIntersecting),
            { threshold: 0.4 } 
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) observer.unobserve(sectionRef.current);
        };
    }, []);

    return (
        <div className="counter-section m-5 px-2" ref={sectionRef} data-aos="fade-up">
            <CounterBox labelTop="HIGH-QUALITY" labelBottom="PRODUCTS" target={60} isVisible={isVisible} />
            <CounterBox labelTop="UNIQUE" labelBottom="DESIGNS" target={120} isVisible={isVisible} />
            <CounterBox labelTop="WORLDWIDE" labelBottom="CLIENTS" target={200} isVisible={isVisible} />
            <CounterBox labelTop="YEARS OF" labelBottom="EXPERIENCE" target={25} isVisible={isVisible} />
        </div>
    );
};

export default CountersSection;
